import React from 'react';
import { CSSObject } from '@emotion/react';
import { useTranslate } from 'nucleus-text';
import useBreakpoints from '@hooks/useBreakpoints';
import AddToCalendar from '@components/sessionDetails/AddToCalendar';
import { Get_Event_Features_And_SpeakersQuery as GetEventFeaturesAndSpeakersQuery } from '@graphql/gql/graphql';
import Row from '@cvent/carina/components/Row';
import Typography from '@cvent/blocks/components/Typography';
import useTheme from '@hooks/useTheme';

interface LandingPageHeaderProps {
  subheader?: JSX.Element;
  title: string;
  isCancelled?: boolean;
  eventInfo: GetEventFeaturesAndSpeakersQuery['eventInfo'];
  callToAction?: React.ReactNode;
}

const useStyles = (): Record<string, CSSObject> => {
  const { mediaIsMobile, mediaIsM, mediaIsS, mediaIsDefaultSize } = useBreakpoints();
  const { font } = useTheme();
  return {
    headerContainer: {
      display: null,
      flexDirection: null,
      marginBottom: 0,
      [mediaIsM]: {
        display: 'flex',
        flexDirection: 'column'
      },
      [mediaIsMobile]: {
        display: 'flex',
        flexDirection: 'column'
      }
    },
    headerText: {
      marginTop: 0,
      textAlign: 'left',
      wordWrap: 'break-word',
      fontWeight: font.base.weight.bold,
      fontSize: font.base.size.h1,
      [mediaIsDefaultSize]: {
        fontSize: font.base.size['7']
      },
      [mediaIsS]: {
        fontSize: font.base.size['7']
      },
      [mediaIsMobile]: {
        textAlign: 'center'
      },
      [mediaIsM]: {
        marginBottom: 8,
        textAlign: 'center'
      },
      marginBottom: 24,
      paddingTop: 8,
      paddingBottom: 8,
      [mediaIsMobile]: {
        marginBottom: 16
      }
    },
    callToActionButtonPreAuthContainer: {
      marginRight: 20,
      marginBottom: 24,
      [mediaIsMobile]: {
        marginRight: 0
      }
    },
    addToCalendarMargin: { marginTop: 6 },
    subheaderContainer: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%'
    }
  };
};

function LandingPageHeader({
  isCancelled,
  subheader,
  title,
  eventInfo,
  callToAction
}: LandingPageHeaderProps): JSX.Element {
  const { headerContainer, headerText, callToActionButtonPreAuthContainer } = useStyles();
  const { translate } = useTranslate();

  return (
    <div css={headerContainer}>
      <Typography css={headerText} as="h1">
        <>{isCancelled ? translate('Event-Canceled-Text', { eventName: title }) : title}</>
      </Typography>
      {!isCancelled && callToAction && <div css={callToActionButtonPreAuthContainer}>{callToAction}</div>}
      {subheader}
      {!isCancelled && (
        <Row justifyContent="flex-start" margin={{ bottom: 0, top: 0 }}>
          <AddToCalendar
            start={eventInfo.start}
            end={eventInfo.end}
            name={eventInfo.title}
            sessionId={eventInfo.id}
            sessionDescription={eventInfo.description}
            eventName={eventInfo.title}
            hideCalendarIcon
          />
        </Row>
      )}
    </div>
  );
}

export default LandingPageHeader;
